import Fido from './Fido';

class CheckMaintenanceMode {
    static isDownForMaintenance(successFn) {
		let fido = new Fido();
		return fido.fetch('/check-maintenance-mode')
			.then((resp) => {
		        const {isDownForMaintenance} = resp;
                successFn(isDownForMaintenance);
            });
        }
}

export default CheckMaintenanceMode;
